import { render, staticRenderFns } from "./TourEdit.vue?vue&type=template&id=5855b0b6&scoped=true"
import script from "./TourEdit.vue?vue&type=script&lang=js"
export * from "./TourEdit.vue?vue&type=script&lang=js"
import style0 from "./TourEdit.vue?vue&type=style&index=0&id=5855b0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5855b0b6",
  null
  
)

export default component.exports